<template>
  <div class="page-container">
    <!-- 搜索表单 -->
    <div class="search-form">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="关键词">
          <el-input
            v-model="searchForm.keyword"
            placeholder="请输入昵称"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        <!-- <el-form-item label="状态">
          <el-select
            v-model="searchForm.status"
            placeholder="请选择状态"
            clearable
          >
            <el-option label="正常" :value="0" />
            <el-option label="禁用" :value="1" />
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-checkbox v-model="searchForm.expiredOnly" @change="handleSearch">
            仅看已过期(正常)
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 工具栏 -->
    <div class="toolbar">
      <div class="toolbar-left">
        <el-button type="primary" icon="el-icon-plus" @click="handleCreate">
          新增用户
        </el-button>
      </div>
      <div class="toolbar-right">
        <el-button icon="el-icon-refresh" @click="loadData">刷新</el-button>
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="tableData"
      :max-height="tableMaxHeight"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="userName" label="用户账号" width="120" />
      <el-table-column prop="nickName" label="昵称" width="120">
        <template slot-scope="scope">
          <div class="user-info">
            <el-avatar
              :size="30"
              :src="scope.row.avatar"
              style="margin-right: 8px"
            >
              {{ scope.row.nickName ? scope.row.nickName.charAt(0) : "U" }}
            </el-avatar>
            {{ scope.row.nickName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="sex" label="性别" width="80">
        <template slot-scope="scope">
          {{ scope.row.sex | genderText }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
            {{ scope.row.status | statusText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="online" label="在线状态" width="80">
        <template slot-scope="scope">
          {{ scope.row.online ? "在线" : "离线" }}
        </template>
      </el-table-column>
      <el-table-column prop="canSendMessage" label="消息权限" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.canSendMessage ? 'success' : 'danger'">
            {{ scope.row.canSendMessage ? "允许" : "禁止" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="expireTime" label="到期时间" width="150">
        <template slot-scope="scope">
          {{ scope.row.expireTime | formatDate }}
          <div
            v-if="isExpired(scope.row.expireTime)"
            style="color: #f56c6c; font-size: 12px"
          >
            已过期 {{ formatExpiredDuration(scope.row.expireTime) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="lastLoginTime" label="最后登录" width="150">
        <template slot-scope="scope">
          {{ scope.row.lastLoginTime | formatDate }}
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" label="注册时间" width="150">
        <template slot-scope="scope">
          {{ scope.row.createdTime | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" fixed="right" align="center">
        <template slot-scope="scope">
          <div class="table-actions">
            <el-button
              size="mini"
              type="success"
              @click="handleManageGroups(scope.row)"
              >群组管理</el-button
            >
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-dropdown
              @command="(command) => handleCommand(command, scope.row)"
            >
              <el-button size="mini">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="resetPassword"
                  >重置密码</el-dropdown-item
                >
                <el-dropdown-item command="forceOffline"
                  >强制下线</el-dropdown-item
                >
                <el-dropdown-item command="delete" divided
                  >删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <!-- <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      />
    </div> -->

    <!-- 新增/编辑对话框 -->
    <user-form
      :visible.sync="formVisible"
      :user-data="currentUser"
      @success="handleFormSuccess"
    />

    <!-- 详情对话框 -->
    <user-detail :visible.sync="detailVisible" :user-data="currentUser" />

    <!-- 群组管理对话框 -->
    <user-group-manager
      :visible.sync="groupManagerVisible"
      :user-data="currentUser"
    />
  </div>
</template>

<script>
import {
  getUserList,
  deleteUser,
  changeUserStatus,
  resetUserPassword,
  forceUserOffline,
} from "@/api/user";
import UserForm from "./components/UserForm";
import UserDetail from "./components/UserDetail";
import UserGroupManager from "./components/UserGroupManager";

export default {
  name: "UserList",
  components: {
    UserForm,
    UserDetail,
    UserGroupManager,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableMaxHeight: 400,
      selectedRows: [],
      searchForm: {
        keyword: "",
        status: null,
        expiredOnly: false,
      },
      pagination: {
        page: 1,
        size: 20,
        total: 0,
      },
      formVisible: false,
      detailVisible: false,
      groupManagerVisible: false,
      currentUser: null,
    };
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.updateTableMaxHeight();
    window.addEventListener("resize", this.updateTableMaxHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableMaxHeight);
  },
  methods: {
    updateTableMaxHeight() {
      this.$nextTick(() => {
        const tableEl = this.$el && this.$el.querySelector(".el-table");
        if (!tableEl) return;

        const top = tableEl.getBoundingClientRect().top;
        const bottomReserve = 24;
        const minHeight = 240;
        this.tableMaxHeight = Math.max(
          minHeight,
          Math.floor(window.innerHeight - top - bottomReserve),
        );
      });
    },
    isExpired(expireTime) {
      if (!expireTime) return false;
      const ts = new Date(expireTime).getTime();
      if (isNaN(ts)) return false;
      return ts < Date.now();
    },

    formatExpiredDuration(expireTime) {
      if (!expireTime) return "";
      const end = new Date(expireTime).getTime();
      const now = Date.now();
      if (isNaN(end) || end >= now) return "";
      let diff = Math.floor((now - end) / 1000); // seconds
      const days = Math.floor(diff / 86400);
      diff %= 86400;
      const hours = Math.floor(diff / 3600);
      diff %= 3600;
      const minutes = Math.floor(diff / 60);
      // 仅显示非零单位，至少展示分钟
      const parts = [];
      if (days) parts.push(`${days}天`);
      if (hours) parts.push(`${hours}小时`);
      parts.push(`${minutes}分钟`);
      return parts.join("");
    },
    async loadData() {
      this.loading = true;
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          size: this.pagination.size,
        };
        if (this.searchForm.expiredOnly) {
          params.status = 0;
          params.sortField = "expireTime";
          params.sortOrder = "asc";
          params.expired = true;
        }
        const response = await getUserList(params);
        let records = response.data.records || response.data || [];
        if (this.searchForm.expiredOnly) {
          const now = Date.now();
          records = records
            .filter(
              (row) =>
                row &&
                row.status === 0 &&
                row.expireTime &&
                new Date(row.expireTime).getTime() < now,
            )
            .sort(
              (a, b) =>
                new Date(a.expireTime).getTime() -
                new Date(b.expireTime).getTime(),
            );
        }
        this.tableData = records;
        this.pagination.total = response.data.total || records.length;
      } catch (error) {
        console.error("加载数据失败:", error);
        this.$message.error("加载数据失败");
      } finally {
        this.loading = false;
        this.updateTableMaxHeight();
      }
    },

    handleSearch() {
      this.pagination.page = 1;
      this.loadData();
    },

    resetSearch() {
      this.searchForm = {
        keyword: "",
        status: null,
        expiredOnly: false,
      };
      this.pagination.page = 1;
      this.loadData();
    },

    handleCreate() {
      this.currentUser = null;
      this.formVisible = true;
    },

    handleView(row) {
      this.currentUser = row;
      this.detailVisible = true;
    },

    handleEdit(row) {
      this.currentUser = row;
      this.formVisible = true;
    },

    handleManageGroups(row) {
      this.currentUser = row;
      this.groupManagerVisible = true;
    },

    async handleCommand(command, row) {
      switch (command) {
        case "enable":
        case "disable":
          await this.handleStatusChange(row, command === "enable" ? 0 : 1);
          break;
        case "resetPassword":
          await this.handleResetPassword(row);
          break;
        case "forceOffline":
          await this.handleForceOffline(row);
          break;
        case "delete":
          await this.handleDelete(row);
          break;
      }
    },

    async handleStatusChange(row, status) {
      try {
        await this.$confirm(
          `确定要${status === 0 ? "启用" : "禁用"}用户"${row.nickName}"吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          },
        );

        await changeUserStatus(row.id, status);
        this.$message.success("操作成功");
        this.loadData();
      } catch (error) {
        if (error !== "cancel") {
          console.error("状态变更失败:", error);
          this.$message.error("操作失败");
        }
      }
    },

    async handleResetPassword(row) {
      try {
        const { value: newPassword } = await this.$prompt(
          "请输入新密码",
          "重置密码",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputValidator: (value) => {
              if (!value || value.length < 6) {
                return "密码不能少于6位";
              }
              return true;
            },
          },
        );

        await resetUserPassword(row.id, newPassword);
        this.$message.success("密码重置成功");
      } catch (error) {
        if (error !== "cancel") {
          console.error("密码重置失败:", error);
          this.$message.error("密码重置失败");
        }
      }
    },

    async handleDelete(row) {
      try {
        await this.$confirm(
          `确定要删除用户"${row.nickName}"吗？此操作不可恢复！`,
          "警告",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          },
        );

        await deleteUser(row.id);
        this.$message.success("删除成功");
        this.loadData();
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除失败:", error);
          this.$message.error("删除失败");
        }
      }
    },

    async handleForceOffline(row) {
      try {
        await this.$confirm(`确定要强制用户"${row.nickName}"下线吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        await forceUserOffline(row.id);
        this.$message.success("强制下线成功");
        this.loadData();
      } catch (error) {
        if (error !== "cancel") {
          console.error("强制下线失败:", error);
          this.$message.error("强制下线失败");
        }
      }
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    handleSizeChange(size) {
      this.pagination.size = size;
      this.loadData();
    },

    handleCurrentChange(page) {
      this.pagination.page = page;
      this.loadData();
    },

    handleFormSuccess() {
      this.formVisible = false;
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  display: flex;
  align-items: center;
}

.table-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: 4px 0;
}

.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>
